"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Column;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _common = require("@nestjs/common");
const _config = require("~/interface/config");
const _FormulaColumn = /*#__PURE__*/ _interop_require_default(require("~/models/FormulaColumn"));
const _LinkToAnotherRecordColumn = /*#__PURE__*/ _interop_require_default(require("~/models/LinkToAnotherRecordColumn"));
const _LookupColumn = /*#__PURE__*/ _interop_require_default(require("~/models/LookupColumn"));
const _RollupColumn = /*#__PURE__*/ _interop_require_default(require("~/models/RollupColumn"));
const _SelectOption = /*#__PURE__*/ _interop_require_default(require("~/models/SelectOption"));
const _Model = /*#__PURE__*/ _interop_require_default(require("~/models/Model"));
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _Sort = /*#__PURE__*/ _interop_require_default(require("~/models/Sort"));
const _Filter = /*#__PURE__*/ _interop_require_default(require("~/models/Filter"));
const _QrCodeColumn = /*#__PURE__*/ _interop_require_default(require("~/models/QrCodeColumn"));
const _BarcodeColumn = /*#__PURE__*/ _interop_require_default(require("~/models/BarcodeColumn"));
const _AIColumn = /*#__PURE__*/ _interop_require_default(require("~/models/AIColumn"));
const _models = require("~/models");
const _extractProps = require("~/helpers/extractProps");
const _catchError = require("~/helpers/catchError");
const _addFormulaErrorIfMissingColumn = /*#__PURE__*/ _interop_require_default(require("~/helpers/addFormulaErrorIfMissingColumn"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _modelUtils = require("~/utils/modelUtils");
const _formulaHelpers = require("~/helpers/formulaHelpers");
const _scriptHelper = require("~/helpers/scriptHelper");
const _nccachedecorator = require("~/decorators/nc-cache.decorator");
const _columninternalmeta = require("~/types/column-internal-meta");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
const selectColors = _nocodbsdk.enumColors.light;
const logger = new _common.Logger('Column');
const requiredColumnsToRecreate = {
    [_nocodbsdk.UITypes.LinkToAnotherRecord]: [
        'type',
        'fk_child_column_id',
        'fk_parent_column_id',
        'fk_related_model_id'
    ],
    [_nocodbsdk.UITypes.Links]: [
        'type',
        'fk_child_column_id',
        'fk_parent_column_id',
        'fk_related_model_id'
    ],
    [_nocodbsdk.UITypes.Rollup]: [
        'fk_relation_column_id',
        'fk_rollup_column_id'
    ],
    [_nocodbsdk.UITypes.Lookup]: [
        'fk_relation_column_id',
        'fk_lookup_column_id'
    ],
    [_nocodbsdk.UITypes.QrCode]: [
        'fk_qr_value_column_id'
    ],
    [_nocodbsdk.UITypes.Barcode]: [
        'fk_barcode_value_column_id'
    ],
    [_nocodbsdk.UITypes.Button]: [
        'type',
        'label'
    ],
    [_nocodbsdk.UITypes.Formula]: [
        'formula'
    ]
};
let Column = class Column {
    async getModel(context, ncMeta = _Noco.default.ncMeta) {
        return _Model.default.get(context, this.fk_model_id, ncMeta);
    }
    static async insert(context, column, ncMeta = _Noco.default.ncMeta) {
        var _column_order;
        if (!column.fk_model_id) _catchError.NcError.badRequest('Missing model id');
        // TODO: fix type
        const insertObj = (0, _extractProps.extractProps)(column, [
            'id',
            'fk_model_id',
            'column_name',
            'title',
            'uidt',
            'dt',
            'np',
            'ns',
            'clen',
            'cop',
            'pk',
            'rqd',
            'un',
            'ct',
            'ai',
            'unique',
            'cdf',
            'cc',
            'csn',
            'dtx',
            'dtxp',
            'dtxs',
            'au',
            'pv',
            'order',
            'base_id',
            'source_id',
            'system',
            'meta',
            'internal_meta',
            'virtual',
            'description',
            'readonly'
        ]);
        if (!insertObj.column_name) {
            insertObj.column_name = column.cn;
        }
        if (!insertObj.title) {
            insertObj.title = column._cn;
        }
        if (insertObj.meta && typeof insertObj.meta === 'object') {
            insertObj.meta = JSON.stringify(insertObj.meta);
        }
        if (insertObj.internal_meta && typeof insertObj.internal_meta === 'object') {
            // Validate internal_meta structure before stringifying
            (0, _columninternalmeta.validateColumnInternalMeta)(insertObj.internal_meta);
            insertObj.internal_meta = JSON.stringify(insertObj.internal_meta);
        }
        insertObj.order = (_column_order = column.order) != null ? _column_order : await ncMeta.metaGetNextOrder(_globals.MetaTable.COLUMNS, {
            fk_model_id: column.fk_model_id
        });
        if (column.validate) {
            if (typeof column.validate === 'string') insertObj.validate = column.validate;
            else insertObj.validate = JSON.stringify(column.validate);
        }
        if (!column.source_id) {
            const model = await _Model.default.getByIdOrName(context, {
                id: column.fk_model_id
            }, ncMeta);
            insertObj.source_id = model.source_id;
        }
        // Fallback to SingleLineText if no UI Datatype is provided
        if (!column.uidt) {
            if (column.dt) {
                const source = await _models.Source.get(context, column.source_id || insertObj.source_id);
                const sqlUi = _nocodbsdk.SqlUiFactory.create(await source.getConnectionConfig());
                insertObj.uidt = sqlUi.getUIType(column) || _nocodbsdk.UITypes.SingleLineText;
            } else {
                insertObj.uidt = _nocodbsdk.UITypes.SingleLineText;
            }
        }
        const row = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, insertObj);
        const col = await this.get(context, {
            colId: row.id
        }, ncMeta);
        await _NocoCache.default.appendToList(context, _globals.CacheScope.COLUMN, [
            column.fk_model_id
        ], `${_globals.CacheScope.COLUMN}:${row.id}`);
        await this.insertColOption(context, column, row.id, ncMeta);
        await _View.default.insertColumnToAllViews(context, {
            fk_column_id: row.id,
            fk_model_id: column.fk_model_id,
            column_show: {
                show: column.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord || column.uidt === _nocodbsdk.UITypes.Links && column.type === 'mm' && !column.view_id ? false : !column.view_id,
                view_id: column.view_id
            },
            column_order: column.column_order
        }, ncMeta);
        if (insertObj.pv === true) {
            await _Model.default.updatePrimaryColumn(context, column.fk_model_id, row.id, ncMeta).catch((e)=>{
                logger.error(`Failed to update primary column for model ${column.fk_model_id}: ${e == null ? void 0 : e.message}`);
            });
        }
        await _View.default.clearSingleQueryCache(context, column.fk_model_id, null, ncMeta);
        (0, _scriptHelper.cleanBaseSchemaCacheForBase)(context.base_id).catch(()=>{
            logger.error('Failed to clean base schema cache');
        });
        return col;
    }
    static async insertColOption(context, column, colId, ncMeta = _Noco.default.ncMeta) {
        switch(column.uidt || column.ui_data_type){
            case _nocodbsdk.UITypes.Lookup:
                {
                    // LookupColumn.insert()
                    await _LookupColumn.default.insert(context, {
                        fk_column_id: colId,
                        fk_relation_column_id: column.fk_relation_column_id,
                        fk_lookup_column_id: column.fk_lookup_column_id
                    }, ncMeta);
                    break;
                }
            case _nocodbsdk.UITypes.Rollup:
                {
                    await _RollupColumn.default.insert(context, {
                        fk_column_id: colId,
                        fk_relation_column_id: column.fk_relation_column_id,
                        fk_rollup_column_id: column.fk_rollup_column_id,
                        rollup_function: column.rollup_function
                    }, ncMeta);
                    break;
                }
            case _nocodbsdk.UITypes.Links:
            case _nocodbsdk.UITypes.LinkToAnotherRecord:
                {
                    var _column_version;
                    // V1 heuristic: hm/bt/oo without junction table are V1
                    // V2 types (om, mo) or anything with junction table uses caller version or defaults to V2
                    const isV1Heuristic = !column.fk_mm_model_id && ([
                        _nocodbsdk.RelationTypes.HAS_MANY,
                        _nocodbsdk.RelationTypes.BELONGS_TO
                    ].includes(column.type) || column.type === _nocodbsdk.RelationTypes.ONE_TO_ONE);
                    const version = isV1Heuristic ? _nocodbsdk.LinksVersion.V1 : (_column_version = column.version) != null ? _column_version : _nocodbsdk.LinksVersion.V2;
                    await _LinkToAnotherRecordColumn.default.insert(context, {
                        fk_column_id: colId,
                        // ref_db_alias
                        type: column.type,
                        // db_type:
                        fk_child_column_id: column.fk_child_column_id,
                        fk_parent_column_id: column.fk_parent_column_id,
                        fk_target_view_id: column.fk_target_view_id,
                        fk_mm_model_id: column.fk_mm_model_id,
                        fk_mm_child_column_id: column.fk_mm_child_column_id,
                        fk_mm_parent_column_id: column.fk_mm_parent_column_id,
                        // cross base link props
                        fk_related_base_id: column.fk_related_base_id,
                        fk_mm_base_id: column.fk_mm_base_id,
                        fk_related_source_id: column.fk_related_source_id,
                        fk_mm_source_id: column.fk_mm_source_id,
                        ur: column.ur,
                        dr: column.dr,
                        fk_index_name: column.fk_index_name,
                        fk_related_model_id: column.fk_related_model_id,
                        virtual: column.virtual,
                        version
                    }, ncMeta);
                    break;
                }
            case _nocodbsdk.UITypes.QrCode:
                {
                    await _QrCodeColumn.default.insert(context, {
                        fk_column_id: colId,
                        fk_qr_value_column_id: column.fk_qr_value_column_id
                    }, ncMeta);
                    break;
                }
            case _nocodbsdk.UITypes.Barcode:
                {
                    await _BarcodeColumn.default.insert(context, {
                        fk_column_id: colId,
                        fk_barcode_value_column_id: column.fk_barcode_value_column_id,
                        barcode_format: column.barcode_format
                    }, ncMeta);
                    break;
                }
            case _nocodbsdk.UITypes.Button:
                {
                    await _models.ButtonColumn.insert(context, {
                        fk_column_id: colId,
                        formula: column == null ? void 0 : column.formula,
                        formula_raw: column == null ? void 0 : column.formula_raw,
                        parsed_tree: column == null ? void 0 : column.parsed_tree,
                        error: column == null ? void 0 : column.error,
                        icon: column == null ? void 0 : column.icon,
                        type: column.type,
                        theme: column.theme,
                        color: column.color,
                        fk_webhook_id: column == null ? void 0 : column.fk_webhook_id,
                        fk_script_id: column == null ? void 0 : column.fk_script_id,
                        label: column.label,
                        fk_integration_id: column.fk_integration_id,
                        model: column.model,
                        output_column_ids: column.output_column_ids,
                        filters: column.filters
                    });
                    break;
                }
            case _nocodbsdk.UITypes.Formula:
                {
                    await _FormulaColumn.default.insert(context, {
                        error: column.error,
                        fk_column_id: colId,
                        formula: column.formula,
                        formula_raw: column.formula_raw,
                        parsed_tree: column.parsed_tree
                    }, ncMeta);
                    break;
                }
            case _nocodbsdk.UITypes.MultiSelect:
                {
                    var _column_colOptions;
                    if (!((_column_colOptions = column.colOptions) == null ? void 0 : _column_colOptions.options)) {
                        var _column_dtxp;
                        const bulkOptions = [];
                        for (const [i, option] of ((_column_dtxp = column.dtxp) == null ? void 0 : _column_dtxp.split(',').entries()) || [].entries()){
                            bulkOptions.push({
                                fk_column_id: colId,
                                title: option.replace(/^'/, '').replace(/'$/, ''),
                                order: i + 1,
                                color: selectColors[i % selectColors.length]
                            });
                        }
                        await _SelectOption.default.bulkInsert(context, bulkOptions, ncMeta);
                    } else {
                        const bulkOptions = [];
                        for (const [i, option] of column.colOptions.options.entries() || [].entries()){
                            // Trim end of enum/set
                            if (column.dt === 'enum' || column.dt === 'set') {
                                option.title = option.title.trimEnd();
                            }
                            bulkOptions.push(_extends({
                                color: selectColors[i % selectColors.length]
                            }, option, {
                                fk_column_id: colId,
                                order: i + 1
                            }));
                        }
                        await _SelectOption.default.bulkInsert(context, bulkOptions, ncMeta);
                    }
                    break;
                }
            case _nocodbsdk.UITypes.SingleSelect:
                {
                    var _column_colOptions1;
                    if (!((_column_colOptions1 = column.colOptions) == null ? void 0 : _column_colOptions1.options)) {
                        var _column_dtxp1;
                        const bulkOptions = [];
                        for (const [i, option] of ((_column_dtxp1 = column.dtxp) == null ? void 0 : _column_dtxp1.split(',').entries()) || [].entries()){
                            bulkOptions.push({
                                fk_column_id: colId,
                                title: option.replace(/^'/, '').replace(/'$/, ''),
                                order: i + 1,
                                color: selectColors[i % selectColors.length]
                            });
                        }
                        await _SelectOption.default.bulkInsert(context, bulkOptions, ncMeta);
                    } else {
                        const bulkOptions = [];
                        for (const [i, option] of column.colOptions.options.entries() || [].entries()){
                            // Trim end of enum/set
                            if (column.dt === 'enum' || column.dt === 'set') {
                                option.title = option.title.trimEnd();
                            }
                            bulkOptions.push(_extends({
                                color: selectColors[i % selectColors.length]
                            }, option, {
                                fk_column_id: colId,
                                order: i + 1
                            }));
                        }
                        await _SelectOption.default.bulkInsert(context, bulkOptions, ncMeta);
                    }
                    break;
                }
            case _nocodbsdk.UITypes.LongText:
                {
                    var _column_meta;
                    if (((_column_meta = column.meta) == null ? void 0 : _column_meta[_nocodbsdk.LongTextAiMetaProp]) === true) {
                        await _AIColumn.default.insert(context, {
                            fk_model_id: column.fk_model_id,
                            fk_column_id: colId,
                            fk_integration_id: column.fk_integration_id,
                            model: column.model,
                            prompt: column.prompt,
                            prompt_raw: column.prompt_raw,
                            error: column.error
                        }, ncMeta);
                    }
                    break;
                }
        }
    }
    async getColOptions(context, ncMeta = _Noco.default.ncMeta) {
        let res;
        switch(this.uidt){
            case _nocodbsdk.UITypes.Lookup:
                res = await _LookupColumn.default.read(context, this.id, ncMeta);
                break;
            case _nocodbsdk.UITypes.Rollup:
                res = await _RollupColumn.default.read(context, this.id, ncMeta);
                break;
            case _nocodbsdk.UITypes.LinkToAnotherRecord:
                res = await _LinkToAnotherRecordColumn.default.read(context, this.id, ncMeta);
                break;
            case _nocodbsdk.UITypes.Links:
                res = await _models.LinksColumn.read(context, this.id, ncMeta);
                break;
            case _nocodbsdk.UITypes.MultiSelect:
                res = await _SelectOption.default.read(context, this.id, ncMeta);
                break;
            case _nocodbsdk.UITypes.SingleSelect:
                res = await _SelectOption.default.read(context, this.id, ncMeta);
                break;
            case _nocodbsdk.UITypes.Formula:
                res = await _FormulaColumn.default.read(context, this.id, ncMeta);
                break;
            case _nocodbsdk.UITypes.Button:
                res = await _models.ButtonColumn.read(context, this.id, ncMeta);
                // add default values if options are missing
                if (!res) {
                    res = {
                        type: 'url',
                        theme: 'solid',
                        color: 'brand',
                        label: 'Button',
                        error: 'Invalid configuration',
                        formula_raw: ''
                    };
                }
                break;
            case _nocodbsdk.UITypes.QrCode:
                res = await _QrCodeColumn.default.read(context, this.id, ncMeta);
                break;
            case _nocodbsdk.UITypes.Barcode:
                res = await _BarcodeColumn.default.read(context, this.id, ncMeta);
                break;
            case _nocodbsdk.UITypes.LongText:
                var _this_meta;
                if (((_this_meta = this.meta) == null ? void 0 : _this_meta[_nocodbsdk.LongTextAiMetaProp]) === true) {
                    res = await _AIColumn.default.read(context, this.id, ncMeta);
                }
                break;
        }
        this.colOptions = res;
        return res;
    }
    async loadModel(context, force = false, ncMeta = _Noco.default.ncMeta) {
        if (!this.model || force) {
            this.model = await _Model.default.getByIdOrName(context, {
                // source_id: this.base_id,
                // db_alias: this.db_alias,
                id: this.fk_model_id
            }, ncMeta);
        }
        return this.model;
    }
    static async list(context, { fk_model_id, fk_default_view_id }, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.COLUMN, [
            fk_model_id
        ]);
        let { list: columnsList } = cachedList;
        const { isNoneList } = cachedList;
        const defaultViewColumns = fk_default_view_id ? await _View.default.getColumns(context, fk_default_view_id, ncMeta) : [];
        const defaultViewColumnMap = defaultViewColumns.reduce((acc, col)=>{
            acc[col.fk_column_id] = col;
            return acc;
        }, {});
        if (!isNoneList && !columnsList.length) {
            columnsList = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
                condition: {
                    fk_model_id
                },
                orderBy: {
                    order: 'asc'
                }
            });
            columnsList.forEach((column)=>{
                column.meta = (0, _modelUtils.parseMetaProp)(column);
                // Parse internal_meta field (internal, not exposed via API)
                column.internal_meta = (0, _modelUtils.parseMetaProp)(column, 'internal_meta');
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.COLUMN, [
                fk_model_id
            ], columnsList);
        }
        columnsList.sort((a, b)=>(a.order != null ? a.order : Infinity) - (b.order != null ? b.order : Infinity));
        return Promise.all(columnsList.map(async (m)=>{
            if (defaultViewColumns.length) {
                var _defaultViewColumnMap_m_id, _defaultViewColumnMap_m_id1;
                m.meta = _extends({}, (0, _modelUtils.parseMetaProp)(m), {
                    defaultViewColOrder: (_defaultViewColumnMap_m_id = defaultViewColumnMap[m.id]) == null ? void 0 : _defaultViewColumnMap_m_id.order,
                    defaultViewColVisibility: (_defaultViewColumnMap_m_id1 = defaultViewColumnMap[m.id]) == null ? void 0 : _defaultViewColumnMap_m_id1.show
                });
            }
            const column = new Column(m);
            await column.getColOptions(context, ncMeta);
            return column;
        }));
    /*const columns = ncMeta
      .knex('nc_models_v2 as tab')
      .select(
        'col.id',
        'col.cn',
        'col._cn',
        'col.uidt',
        'rel.rel_cn',
        'rel.ref_rel_cn',
        'rel.id as rel_id'
      )
      .join('nc_columns_v2 as col', 'tab.id', 'col.model_id')
      .leftJoin(
        ncMeta
          .knex('nc_col_relations_v2 as r')
          .select(
            'r.*',
            'col1.cn as rel_cn',
            'col1._cn as _rel_cn',
            'col2.cn as ref_rel_cn',
            'col2._cn as _ref_rel_cn'
          )
          .join('nc_columns_v2 as col1', 'col1.id', 'r.rel_column_id')
          .join('nc_columns_v2 as col2', 'col2.id', 'r.ref_rel_column_id')
          .as('rel'),
        'col.id',
        'rel.column_id'
      )
      .condition(condition)
      .where({
        'tab.source_id': source_id,
        'tab.db_alias': db_alias
      });

    return columns.map(c => new Column(c));*/ }
    static async get(context, { colId }, ncMeta = _Noco.default.ncMeta) {
        let colData = colId && await _NocoCache.default.get(context, `${_globals.CacheScope.COLUMN}:${colId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!colData) {
            colData = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, colId);
            if (colData) {
                try {
                    colData.meta = JSON.parse(colData.meta);
                } catch (unused) {
                    colData.meta = {};
                }
                colData.internal_meta = (0, _modelUtils.parseMetaProp)(colData, 'internal_meta');
                await _NocoCache.default.set(context, `${_globals.CacheScope.COLUMN}:${colId}`, colData);
            }
        }
        if (colData) {
            const column = new Column(colData);
            await column.getColOptions(_extends({}, context, {
                workspace_id: column.fk_workspace_id,
                base_id: column.base_id
            }), ncMeta);
            return column;
        }
        return null;
    }
    static async delete(context, id, ncMeta = _Noco.default.ncMeta) {
        return Column.delete2(context, {
            id
        }, ncMeta);
    }
    static async delete2(context, { id, beforeRelatedColumnDelete, afterRelatedColumnDelete, beforeRelatedColumnUpdate, afterRelatedColumnUpdate }, ncMeta = _Noco.default.ncMeta) {
        const col = await this.get(context, {
            colId: id
        }, ncMeta);
        // if column is not found, return
        if (!col) {
            return;
        }
        // If the column is one of CreatedBy, LastModifiedBy, CreatedAt, or LastModifiedAt
        // and it is a system column, then delete its alias columns as well.
        // This deletion is only performed through meta-sync because system columns
        // cannot be deleted via API calls.
        if ([
            _nocodbsdk.UITypes.CreatedTime,
            _nocodbsdk.UITypes.LastModifiedTime,
            _nocodbsdk.UITypes.LastModifiedBy,
            _nocodbsdk.UITypes.CreatedBy
        ].includes(col.uidt) && col.system) {
            const aliasCols = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
                condition: {
                    uidt: col.uidt,
                    system: false
                }
            });
            for (const aliasCol of aliasCols){
                await Column.delete(context, aliasCol.id, ncMeta);
            }
        }
        // todo: or instead of delete reset related foreign key value to null and handle in BaseModel
        // get qr code columns and delete
        {
            const qrCodeCols = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_QRCODE, {
                condition: {
                    fk_qr_value_column_id: id
                }
            });
            for (const qrCodeCol of qrCodeCols){
                await (beforeRelatedColumnDelete == null ? void 0 : beforeRelatedColumnDelete(context, qrCodeCol.fk_column_id));
                await Column.delete(context, qrCodeCol.fk_column_id, ncMeta);
                await (afterRelatedColumnDelete == null ? void 0 : afterRelatedColumnDelete(context, qrCodeCol.fk_column_id));
            }
        }
        {
            const barcodeCols = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_BARCODE, {
                condition: {
                    fk_barcode_value_column_id: id
                }
            });
            for (const barcodeCol of barcodeCols){
                await (beforeRelatedColumnDelete == null ? void 0 : beforeRelatedColumnDelete(context, barcodeCol.fk_column_id));
                await Column.delete(context, barcodeCol.fk_column_id, ncMeta);
                await (afterRelatedColumnDelete == null ? void 0 : afterRelatedColumnDelete(context, barcodeCol.fk_column_id));
            }
        }
        // get lookup columns and delete
        {
            const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.COL_LOOKUP, [
                id
            ]);
            let { list: lookups } = cachedList;
            const { isNoneList } = cachedList;
            if (!isNoneList && !lookups.length) {
                lookups = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_LOOKUP, {
                    condition: {
                        fk_lookup_column_id: id
                    }
                });
            }
            for (const lookup of lookups){
                await (beforeRelatedColumnDelete == null ? void 0 : beforeRelatedColumnDelete(context, lookup.fk_column_id));
                await Column.delete(context, lookup.fk_column_id, ncMeta);
                await (afterRelatedColumnDelete == null ? void 0 : afterRelatedColumnDelete(context, lookup.fk_column_id));
            }
        }
        // get rollup/links column and delete
        {
            const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.COL_ROLLUP, [
                id
            ]);
            let { list: rollups } = cachedList;
            const { isNoneList } = cachedList;
            if (!isNoneList && !rollups.length) {
                rollups = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_ROLLUP, {
                    condition: {
                        fk_rollup_column_id: id
                    }
                });
            }
            for (const rollup of rollups){
                await (beforeRelatedColumnDelete == null ? void 0 : beforeRelatedColumnDelete(context, rollup.fk_column_id));
                await Column.delete(context, rollup.fk_column_id, ncMeta);
                await (afterRelatedColumnDelete == null ? void 0 : afterRelatedColumnDelete(context, rollup.fk_column_id));
            }
        }
        // get all cross base link columns and delete any lookup/rollup columns
        {
            const columns = await Column.list(context, {
                fk_model_id: col.fk_model_id
            });
            // check in all cross base link lookup columns
            for (const column of columns){
                if (!(0, _nocodbsdk.isLinksOrLTAR)(column.uidt)) continue;
                const colOptions = await column.getColOptions(context, ncMeta);
                if (!(colOptions == null ? void 0 : colOptions.fk_related_base_id) || colOptions.fk_related_base_id === col.base_id) continue;
                // get lookup columns and delete
                const lookupAndRollupColumns = await ncMeta.metaList2(context.workspace_id, colOptions.fk_related_base_id, _globals.MetaTable.COL_LOOKUP, {
                    condition: {
                        fk_lookup_column_id: id
                    }
                });
                for (const lookupAndRollupColumn of lookupAndRollupColumns){
                    await (beforeRelatedColumnDelete == null ? void 0 : beforeRelatedColumnDelete(_extends({}, context, {
                        base_id: colOptions.fk_related_base_id
                    }), lookupAndRollupColumn.fk_column_id));
                    await Column.delete(_extends({}, context, {
                        base_id: colOptions.fk_related_base_id
                    }), lookupAndRollupColumn.fk_column_id, ncMeta);
                    await (afterRelatedColumnDelete == null ? void 0 : afterRelatedColumnDelete(_extends({}, context, {
                        base_id: colOptions.fk_related_base_id
                    }), lookupAndRollupColumn.fk_column_id));
                }
                // get rollup columns and delete
                const rollupColumns = await ncMeta.metaList2(context.workspace_id, colOptions.fk_related_base_id, _globals.MetaTable.COL_ROLLUP, {
                    condition: {
                        fk_rollup_column_id: id
                    }
                });
                for (const rollupColumn of rollupColumns){
                    await (beforeRelatedColumnDelete == null ? void 0 : beforeRelatedColumnDelete(_extends({}, context, {
                        base_id: colOptions.fk_related_base_id
                    }), rollupColumn.fk_column_id));
                    await Column.delete(_extends({}, context, {
                        base_id: colOptions.fk_related_base_id
                    }), rollupColumn.fk_column_id, ncMeta);
                    await (afterRelatedColumnDelete == null ? void 0 : afterRelatedColumnDelete(_extends({}, context, {
                        base_id: colOptions.fk_related_base_id
                    }), rollupColumn.fk_column_id));
                }
            }
        }
        {
            const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.COLUMN, [
                col.fk_model_id
            ]);
            let { list: buttonColumns } = cachedList;
            const { isNoneList } = cachedList;
            if (!isNoneList && !buttonColumns.length) {
                buttonColumns = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
                    condition: {
                        fk_model_id: col.fk_model_id,
                        uidt: _nocodbsdk.UITypes.Button
                    }
                });
            }
            buttonColumns = buttonColumns.filter((c)=>c.uidt === _nocodbsdk.UITypes.Button);
            for (const buttonCol of buttonColumns){
                const button = await new Column(buttonCol).getColOptions(context, ncMeta);
                if (button.type === 'url') {
                    if (button.formula && (0, _addFormulaErrorIfMissingColumn.default)({
                        formula: button,
                        columnId: id,
                        title: col == null ? void 0 : col.title
                    })) {
                        await (beforeRelatedColumnUpdate == null ? void 0 : beforeRelatedColumnUpdate(context, buttonCol.id));
                        await _models.ButtonColumn.update(context, buttonCol.id, button, ncMeta);
                        await (afterRelatedColumnUpdate == null ? void 0 : afterRelatedColumnUpdate(context, buttonCol.id));
                    }
                }
            }
        }
        {
            const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.COLUMN, [
                col.fk_model_id
            ]);
            let { list: aiColumns } = cachedList;
            const { isNoneList } = cachedList;
            if (!isNoneList && !aiColumns.length) {
                aiColumns = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
                    condition: {
                        fk_model_id: col.fk_model_id,
                        uidt: _nocodbsdk.UITypes.LongText
                    }
                });
            }
            (0, _modelUtils.parseMetaProp)(col);
            aiColumns = aiColumns.filter((c)=>(0, _nocodbsdk.isAIPromptCol)(c));
            for (const aiCol of aiColumns){
                const ai = await new Column(aiCol).getColOptions(context, ncMeta);
                if (!ai) continue;
                /*
          if prompt includes deleted column id {column_id}, add error and update
        */ if (ai.prompt && ai.prompt.match(/{column_id}/)) {
                    ai.error = `Field '${col.title}' not found`;
                    await (beforeRelatedColumnUpdate == null ? void 0 : beforeRelatedColumnUpdate(context, aiCol.id));
                    await _AIColumn.default.update(context, aiCol.id, ai, ncMeta);
                    await (afterRelatedColumnUpdate == null ? void 0 : afterRelatedColumnUpdate(context, aiCol.id));
                }
            }
        }
        {
            const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.COLUMN, [
                col.fk_model_id
            ]);
            let { list: formulaColumns } = cachedList;
            const { isNoneList } = cachedList;
            if (!isNoneList && !formulaColumns.length) {
                formulaColumns = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
                    condition: {
                        fk_model_id: col.fk_model_id,
                        uidt: _nocodbsdk.UITypes.Formula
                    }
                });
            }
            formulaColumns = formulaColumns.filter((c)=>c.uidt === _nocodbsdk.UITypes.Formula);
            for (const formulaCol of formulaColumns){
                const formula = await new Column(formulaCol).getColOptions(context, ncMeta);
                if (formula.formula && (0, _addFormulaErrorIfMissingColumn.default)({
                    formula,
                    columnId: id,
                    title: col == null ? void 0 : col.title
                })) {
                    await (beforeRelatedColumnUpdate == null ? void 0 : beforeRelatedColumnUpdate(context, formulaCol.id));
                    await _FormulaColumn.default.update(context, formulaCol.id, formula, ncMeta);
                    await (afterRelatedColumnUpdate == null ? void 0 : afterRelatedColumnUpdate(context, formulaCol.id));
                }
            }
        }
        //  if relation column check lookup and rollup and delete
        if ((0, _nocodbsdk.isLinksOrLTAR)(col.uidt)) {
            {
                // get lookup columns using relation and delete
                const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.COL_LOOKUP, [
                    id
                ]);
                let { list: lookups } = cachedList;
                const { isNoneList } = cachedList;
                if (!isNoneList && !lookups.length) {
                    lookups = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_LOOKUP, {
                        condition: {
                            fk_relation_column_id: id
                        }
                    });
                }
                for (const lookup of lookups){
                    await (afterRelatedColumnDelete == null ? void 0 : afterRelatedColumnDelete(context, lookup.fk_column_id));
                    await Column.delete(context, lookup.fk_column_id, ncMeta);
                    await (afterRelatedColumnDelete == null ? void 0 : afterRelatedColumnDelete(context, lookup.fk_column_id));
                }
            }
            {
                // get rollup columns using relation and delete
                const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.COL_ROLLUP, [
                    id
                ]);
                let { list: rollups } = cachedList;
                const { isNoneList } = cachedList;
                if (!isNoneList && !rollups.length) {
                    rollups = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_ROLLUP, {
                        condition: {
                            fk_relation_column_id: id
                        }
                    });
                }
                for (const rollup of rollups){
                    await (afterRelatedColumnDelete == null ? void 0 : afterRelatedColumnDelete(context, rollup.fk_column_id));
                    await Column.delete(context, rollup.fk_column_id, ncMeta);
                    await (afterRelatedColumnDelete == null ? void 0 : afterRelatedColumnDelete(context, rollup.fk_column_id));
                }
            }
        }
        // delete sorts
        {
            const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.SORT, [
                id
            ]);
            let { list: sorts } = cachedList;
            const { isNoneList } = cachedList;
            if (!isNoneList && !sorts.length) {
                sorts = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.SORT, {
                    condition: {
                        fk_column_id: id
                    }
                });
            }
            for (const sort of sorts){
                await _Sort.default.delete(context, sort.id, ncMeta);
            }
        }
        // delete filters
        {
            const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.COLUMN,
                id
            ]);
            let { list: filters } = cachedList;
            const { isNoneList } = cachedList;
            if (!isNoneList && !filters.length) {
                filters = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                    condition: {
                        fk_column_id: id
                    }
                });
            }
            for (const filter of filters){
                if (filter.fk_parent_id) continue;
                await _Filter.default.delete(context, filter.id, ncMeta);
            }
        }
        {
            await _Filter.default.deleteAllByParentColumn(context, id, ncMeta);
        }
        // Set Gallery & Kanban view `fk_cover_image_col_id` value to null
        await Column.deleteCoverImageColumnId(context, id, ncMeta);
        // Delete from view columns
        let colOptionTableName = null;
        let cacheScopeName = null;
        switch(col.uidt){
            case _nocodbsdk.UITypes.Rollup:
                colOptionTableName = _globals.MetaTable.COL_ROLLUP;
                cacheScopeName = _globals.CacheScope.COL_ROLLUP;
                break;
            case _nocodbsdk.UITypes.Lookup:
                colOptionTableName = _globals.MetaTable.COL_LOOKUP;
                cacheScopeName = _globals.CacheScope.COL_LOOKUP;
                break;
            case _nocodbsdk.UITypes.LinkToAnotherRecord:
            case _nocodbsdk.UITypes.Links:
                colOptionTableName = _globals.MetaTable.COL_RELATIONS;
                cacheScopeName = _globals.CacheScope.COL_RELATION;
                break;
            case _nocodbsdk.UITypes.MultiSelect:
            case _nocodbsdk.UITypes.SingleSelect:
                colOptionTableName = _globals.MetaTable.COL_SELECT_OPTIONS;
                cacheScopeName = _globals.CacheScope.COL_SELECT_OPTION;
                break;
            case _nocodbsdk.UITypes.Formula:
                colOptionTableName = _globals.MetaTable.COL_FORMULA;
                cacheScopeName = _globals.CacheScope.COL_FORMULA;
                break;
            case _nocodbsdk.UITypes.Button:
                colOptionTableName = _globals.MetaTable.COL_BUTTON;
                cacheScopeName = _globals.CacheScope.COL_BUTTON;
                break;
            case _nocodbsdk.UITypes.QrCode:
                colOptionTableName = _globals.MetaTable.COL_QRCODE;
                cacheScopeName = _globals.CacheScope.COL_QRCODE;
                break;
            case _nocodbsdk.UITypes.Barcode:
                colOptionTableName = _globals.MetaTable.COL_BARCODE;
                cacheScopeName = _globals.CacheScope.COL_BARCODE;
                break;
            case _nocodbsdk.UITypes.LongText:
                var _col_meta;
                if (((_col_meta = col.meta) == null ? void 0 : _col_meta[_nocodbsdk.LongTextAiMetaProp]) === true) {
                    colOptionTableName = _globals.MetaTable.COL_LONG_TEXT;
                    cacheScopeName = _globals.CacheScope.COL_LONG_TEXT;
                }
                break;
        }
        if (colOptionTableName && cacheScopeName) {
            await (beforeRelatedColumnDelete == null ? void 0 : beforeRelatedColumnDelete(context, col.id));
            await ncMeta.metaDelete(context.workspace_id, context.base_id, colOptionTableName, {
                fk_column_id: col.id
            });
            await (afterRelatedColumnDelete == null ? void 0 : afterRelatedColumnDelete(context, col.id));
            await _NocoCache.default.deepDel(context, `${cacheScopeName}:${col.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        }
        // Delete from all view columns
        const viewColumnTables = [
            _globals.MetaTable.GRID_VIEW_COLUMNS,
            _globals.MetaTable.FORM_VIEW_COLUMNS,
            _globals.MetaTable.KANBAN_VIEW_COLUMNS,
            _globals.MetaTable.GALLERY_VIEW_COLUMNS,
            _globals.MetaTable.CALENDAR_VIEW_COLUMNS
        ];
        const viewColumnCacheScope = [
            _globals.CacheScope.GRID_VIEW_COLUMN,
            _globals.CacheScope.FORM_VIEW_COLUMN,
            _globals.CacheScope.KANBAN_VIEW_COLUMN,
            _globals.CacheScope.GALLERY_VIEW_COLUMN,
            _globals.CacheScope.CALENDAR_VIEW_COLUMN
        ];
        for(let i = 0; i < viewColumnTables.length; i++){
            const table = viewColumnTables[i];
            const cacheScope = viewColumnCacheScope[i];
            const viewColumns = await ncMeta.metaList2(context.workspace_id, context.base_id, table, {
                condition: {
                    fk_column_id: id
                }
            });
            await ncMeta.metaDelete(context.workspace_id, context.base_id, table, {
                fk_column_id: id
            });
            for (const viewColumn of viewColumns){
                await _NocoCache.default.deepDel(context, `${cacheScope}:${viewColumn.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
            }
        }
        // Get LTAR columns in which current column is referenced as foreign key
        const ltarColumns = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_RELATIONS, {
            xcCondition: {
                _or: [
                    {
                        fk_child_column_id: {
                            eq: col.id
                        }
                    },
                    {
                        fk_parent_column_id: {
                            eq: col.id
                        }
                    },
                    {
                        fk_mm_child_column_id: {
                            eq: col.id
                        }
                    },
                    {
                        fk_mm_parent_column_id: {
                            eq: col.id
                        }
                    }
                ]
            }
        });
        // Delete LTAR columns in which current column is referenced as foreign key
        for (const ltarColumn of ltarColumns){
            await (beforeRelatedColumnDelete == null ? void 0 : beforeRelatedColumnDelete(context, ltarColumn.fk_column_id));
            await Column.delete(context, ltarColumn.fk_column_id, ncMeta);
            await (afterRelatedColumnDelete == null ? void 0 : afterRelatedColumnDelete(context, ltarColumn.fk_column_id));
        }
        // Delete FileReference
        await _models.FileReference.bulkDelete(context, {
            fk_column_id: col.id
        }, ncMeta);
        // Columns
        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, col.id);
        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.COLUMN}:${col.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        // on column delete, delete any optimised single query cache
        {
            await _View.default.clearSingleQueryCache(context, col.fk_model_id, null, ncMeta);
        }
        (0, _scriptHelper.cleanBaseSchemaCacheForBase)(context.base_id).catch(()=>{
            logger.error('Failed to clean base schema cache');
        });
    }
    static async update(context, colId, column, ncMeta = _Noco.default.ncMeta, skipFormulaInvalidate = false) {
        const oldCol = await Column.get(context, {
            colId
        }, ncMeta);
        const requiredColAvail = !requiredColumnsToRecreate[oldCol.uidt] || requiredColumnsToRecreate[oldCol.uidt].every((k)=>column[k]);
        if (requiredColAvail) {
            switch(oldCol.uidt){
                case _nocodbsdk.UITypes.Lookup:
                    {
                        // LookupColumn.insert()
                        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.COL_LOOKUP, {
                            fk_column_id: colId
                        });
                        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.COL_LOOKUP}:${colId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
                        break;
                    }
                case _nocodbsdk.UITypes.Rollup:
                    {
                        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.COL_ROLLUP, {
                            fk_column_id: colId
                        });
                        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.COL_ROLLUP}:${colId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
                        break;
                    }
                case _nocodbsdk.UITypes.Links:
                case _nocodbsdk.UITypes.LinkToAnotherRecord:
                    {
                        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.COL_RELATIONS, {
                            fk_column_id: colId
                        });
                        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.COL_RELATION}:${colId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
                        break;
                    }
                case _nocodbsdk.UITypes.Formula:
                    {
                        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.COL_FORMULA, {
                            fk_column_id: colId
                        });
                        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.COL_FORMULA}:${colId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
                        break;
                    }
                case _nocodbsdk.UITypes.Button:
                    {
                        await _Filter.default.deleteAllByButtonColumn(context, colId, ncMeta);
                        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.COL_BUTTON, {
                            fk_column_id: colId
                        });
                        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.COL_BUTTON}:${colId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
                        break;
                    }
                case _nocodbsdk.UITypes.QrCode:
                    {
                        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.COL_QRCODE, {
                            fk_column_id: colId
                        });
                        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.COL_QRCODE}:${colId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
                        break;
                    }
                case _nocodbsdk.UITypes.Barcode:
                    {
                        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.COL_BARCODE, {
                            fk_column_id: colId
                        });
                        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.COL_BARCODE}:${colId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
                        break;
                    }
                case _nocodbsdk.UITypes.MultiSelect:
                case _nocodbsdk.UITypes.SingleSelect:
                    {
                        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.COL_SELECT_OPTIONS, {
                            fk_column_id: colId
                        });
                        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.COL_SELECT_OPTION}:${colId}:list`, _globals.CacheDelDirection.PARENT_TO_CHILD);
                        break;
                    }
                case _nocodbsdk.UITypes.LongText:
                    {
                        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.COL_LONG_TEXT, {
                            fk_column_id: colId
                        });
                        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.COL_LONG_TEXT}:${colId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
                        break;
                    }
            }
        }
        const updateObj = (0, _extractProps.extractProps)(column, [
            'column_name',
            'title',
            'description',
            'uidt',
            'dt',
            'np',
            'ns',
            'clen',
            'cop',
            'pk',
            'rqd',
            'un',
            'ct',
            'ai',
            'unique',
            'cdf',
            'cc',
            'csn',
            'dtx',
            'dtxp',
            'dtxs',
            'au',
            'pv',
            'system',
            'validate',
            'meta',
            'internal_meta',
            'readonly'
        ]);
        if (column.validate) {
            if (typeof column.validate === 'string') updateObj.validate = column.validate;
            else updateObj.validate = JSON.stringify(column.validate);
        }
        // get qr code columns and delete if target type is not supported by QR code column type
        if (!_nocodbsdk.AllowedColumnTypesForQrAndBarcodes.includes(updateObj.uidt)) {
            const qrCodeCols = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_QRCODE, {
                condition: {
                    fk_qr_value_column_id: colId
                }
            });
            const barcodeCols = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_BARCODE, {
                condition: {
                    fk_barcode_value_column_id: colId
                }
            });
            for (const qrCodeCol of qrCodeCols){
                await Column.delete(context, qrCodeCol.fk_column_id, ncMeta);
            }
            for (const barcodeCol of barcodeCols){
                await Column.delete(context, barcodeCol.fk_column_id, ncMeta);
            }
        }
        if (column.column_order && column.column_order.order && column.column_order.view_id) {
            const viewColumn = (await _View.default.getColumns(context, column.column_order.view_id, ncMeta)).find((col)=>col.fk_column_id === column.id);
            await _View.default.updateColumn(context, column.column_order.view_id, viewColumn.id, {
                order: column.column_order.order
            }, ncMeta);
        }
        if (column.uidt && oldCol.uidt === _nocodbsdk.UITypes.Attachment && oldCol.uidt !== column.uidt) {
            // Set Gallery & Kanban view `fk_cover_image_col_id` value to null
            await Column.deleteCoverImageColumnId(context, colId, ncMeta);
        }
        // Validate internal_meta if present
        if (updateObj.internal_meta && typeof updateObj.internal_meta === 'object') {
            const { validateColumnInternalMeta } = await Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("~/types/column-internal-meta")));
            validateColumnInternalMeta(updateObj.internal_meta);
        }
        // set meta and internal_meta (internal_meta is internal, not exposed via API)
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, (0, _modelUtils.prepareForDb)(updateObj, [
            'meta',
            'internal_meta'
        ]), colId);
        await _NocoCache.default.update(context, `${_globals.CacheScope.COLUMN}:${colId}`, (0, _modelUtils.prepareForResponse)(updateObj, [
            'meta',
            'internal_meta'
        ]));
        // insert new col options only if existing colOption meta is deleted
        if (requiredColAvail) {
            await this.insertColOption(context, column, colId, ncMeta);
        }
        // on column update, delete any optimised single query cache
        await _View.default.clearSingleQueryCache(context, oldCol.fk_model_id, null, ncMeta);
        const updatedColumn = await Column.get(context, {
            colId
        }, ncMeta);
        if (!skipFormulaInvalidate) {
            // invalidate formula/button parsed-tree in which current column is used
            // whenever a new request comes for that formula, it will be populated again
            (0, _formulaHelpers.getFormulasReferredTheColumn)(context, {
                column: updatedColumn,
                columns: await Column.list(context, {
                    fk_model_id: oldCol.fk_model_id
                }, ncMeta)
            }, ncMeta).then(async (formulas)=>{
                for (const formula of formulas){
                    if (formula.uidt === _nocodbsdk.UITypes.Formula) {
                        await _FormulaColumn.default.update(context, formula.id, {
                            parsed_tree: null
                        }, ncMeta);
                    } else if (formula.uidt === _nocodbsdk.UITypes.Button) {
                        await _models.ButtonColumn.update(context, formula.id, {
                            parsed_tree: null
                        }, ncMeta);
                    }
                }
            })// ignore the error and continue, if formula/button is no longer valid it will be captured in the next run
            .catch((err)=>{
                logger.error(err);
            });
        }
        const refTableIds = new Set();
        // clear any related table cache if updating a FK column
        {
            // Get LTAR columns in which current column is referenced as foreign key
            const ltarColumns = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_RELATIONS, {
                xcCondition: {
                    _and: [
                        {
                            _or: [
                                {
                                    fk_child_column_id: {
                                        eq: colId
                                    }
                                },
                                {
                                    fk_parent_column_id: {
                                        eq: colId
                                    }
                                },
                                {
                                    fk_mm_child_column_id: {
                                        eq: colId
                                    }
                                },
                                {
                                    fk_mm_parent_column_id: {
                                        eq: colId
                                    }
                                }
                            ]
                        },
                        {
                            fk_related_model_id: {
                                neq: oldCol.fk_model_id
                            }
                        }
                    ]
                }
            });
            for (const linkCol of ltarColumns){
                refTableIds.add(linkCol.fk_related_model_id);
            }
        }
        const relationColIds = new Set();
        // get LTAR relation columns
        {
            if (oldCol.pv) {
                // Get LTAR columns in which current column is referenced as foreign key
                const ltarColumns = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_RELATIONS, {
                    xcCondition: {
                        _and: [
                            {
                                fk_related_model_id: {
                                    eq: oldCol.fk_model_id
                                }
                            }
                        ]
                    }
                });
                for (const ltarCol of ltarColumns){
                    relationColIds.add(ltarCol.fk_column_id);
                }
            }
        }
        // get LTAR/Links relation column id of Lookup
        {
            const lkColumns = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_LOOKUP, {
                xcCondition: {
                    _and: [
                        {
                            fk_lookup_column_id: {
                                eq: oldCol.id
                            }
                        }
                    ]
                }
            });
            for (const lkCol of lkColumns){
                relationColIds.add(lkCol.fk_relation_column_id);
            }
        }
        // get LTAR/Links relation column id of Rollup
        {
            const rlColumns = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_ROLLUP, {
                xcCondition: {
                    _and: [
                        {
                            fk_rollup_column_id: {
                                eq: oldCol.id
                            }
                        }
                    ]
                }
            });
            for (const rlCol of rlColumns){
                relationColIds.add(rlCol.fk_relation_column_id);
            }
        }
        if (relationColIds.size > 0) {
            const ltarColumns = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
                xcCondition: {
                    _and: [
                        {
                            id: {
                                in: [
                                    ...relationColIds
                                ]
                            }
                        }
                    ]
                }
            });
            for (const linkCol of ltarColumns){
                refTableIds.add(linkCol.fk_model_id);
            }
        }
        // remove self link
        refTableIds.delete(oldCol.fk_model_id);
        for (const modelId of [
            ...refTableIds
        ]){
            await _View.default.clearSingleQueryCache(context, modelId, null, ncMeta);
        }
        (0, _scriptHelper.cleanBaseSchemaCacheForBase)(context.base_id).catch(()=>{
            logger.error('Failed to clean base schema cache');
        });
        return this.get(context, {
            colId
        }, ncMeta);
    }
    static async updateCustomIndexName(context, colId, customIndexName, ncMeta = _Noco.default.ncMeta) {
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
            custom_index_name: customIndexName != null ? customIndexName : null
        }, colId);
        await _NocoCache.default.update(context, `${_globals.CacheScope.COLUMN}:${colId}`, {
            custom_index_name: customIndexName
        });
    }
    static async updateFormulaColumnToNewType(context, { formulaColumn, destinationColumn, ncMeta = _Noco.default.ncMeta }) {
        const updateObj = (0, _extractProps.extractProps)(destinationColumn, [
            'column_name',
            'title',
            'description',
            'uidt',
            'dt',
            'np',
            'ns',
            'clen',
            'cop',
            'pk',
            'rqd',
            'un',
            'ct',
            'ai',
            'unique',
            'cdf',
            'cc',
            'csn',
            'dtx',
            'dtxp',
            'dtxs',
            'au',
            'pv',
            'system',
            'validate',
            'meta'
        ]);
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, (0, _modelUtils.prepareForDb)(updateObj), formulaColumn.id);
        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.COL_FORMULA, {
            fk_column_id: formulaColumn.id
        });
        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, destinationColumn.id);
        // update the caches to reflect new columns
        await _NocoCache.default.update(context, `${_globals.CacheScope.COLUMN}:${formulaColumn.id}`, (0, _modelUtils.prepareForResponse)(updateObj));
        await _NocoCache.default.del(context, `${_globals.CacheScope.COLUMN}:${destinationColumn.id}`);
    }
    static async updateAlias(context, colId, { title }, ncMeta = _Noco.default.ncMeta) {
        // set meta
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
            title
        }, colId);
        await _NocoCache.default.update(context, `${_globals.CacheScope.COLUMN}:${colId}`, {
            title
        });
        const column = await Column.get(context, {
            colId
        }, ncMeta);
        await _View.default.clearSingleQueryCache(context, column.fk_model_id, null, ncMeta);
    }
    getValidators() {
        if (this.validate && typeof this.validate === 'string') try {
            return JSON.parse(this.validate);
        } catch (unused) {}
        return null;
    }
    async delete(context, ncMeta = _Noco.default.ncMeta) {
        return await Column.delete(context, this.id, ncMeta);
    }
    static async checkTitleAvailable(context, { column_name, fk_model_id, exclude_id }, ncMeta = _Noco.default.ncMeta) {
        return !await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
            column_name,
            fk_model_id
        }, null, exclude_id && {
            id: {
                neq: exclude_id
            }
        });
    }
    static async checkAliasAvailable(context, { title, fk_model_id, exclude_id }, ncMeta = _Noco.default.ncMeta) {
        return !await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
            title,
            fk_model_id
        }, null, exclude_id && {
            id: {
                neq: exclude_id
            }
        });
    }
    static async markAsSystemField(context, colId, system = true, ncMeta = _Noco.default.ncMeta) {
        // update system field in meta db
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
            system
        }, colId);
        await _NocoCache.default.update(context, `${_globals.CacheScope.COLUMN}:${colId}`, {
            system
        });
    }
    static getMaxColumnNameLength(sqlClientType) {
        // no limit for sqlite but set as 255
        let fieldLengthLimit = 255;
        if (sqlClientType === 'mysql2' || sqlClientType === 'mysql') {
            fieldLengthLimit = 64;
        } else if (sqlClientType === 'pg') {
            fieldLengthLimit = 59;
        }
        return fieldLengthLimit;
    }
    static async updateMeta(context, { colId, meta }, ncMeta = _Noco.default.ncMeta) {
        // set meta
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, (0, _modelUtils.prepareForDb)({
            meta
        }), colId);
        await _NocoCache.default.update(context, `${_globals.CacheScope.COLUMN}:${colId}`, (0, _modelUtils.prepareForResponse)({
            meta
        }));
    }
    static async updateValidation(context, { colId, validate }, ncMeta = _Noco.default.ncMeta) {
        // set meta
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, (0, _modelUtils.prepareForDb)({
            validate
        }, 'validate'), colId);
        await _NocoCache.default.update(context, `${_globals.CacheScope.COLUMN}:${colId}`, {
            validate
        });
    }
    static async updateTargetView(context, { colId, fk_target_view_id }, ncMeta = _Noco.default.ncMeta) {
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COL_RELATIONS, {
            fk_target_view_id
        }, {
            fk_column_id: colId
        });
        await _NocoCache.default.update(context, `${_globals.CacheScope.COL_RELATION}:${colId}`, {
            fk_target_view_id
        });
    }
    static async bulkInsert(context, param, ncMeta = _Noco.default.ncMeta) {
        const extractedColumnMetas = [];
        const columns = [];
        // add fk_model_id
        for (const column of param.columns){
            // pre-populate column meta to use while inserting colOptions
            const id = await ncMeta.genNanoid(_globals.MetaTable.COLUMNS);
            const colWithId = _extends({}, column, {
                id,
                base_id: param.base_id,
                source_id: param.source_id,
                fk_model_id: param.fk_model_id
            });
            const insertObj = (0, _extractProps.extractProps)(colWithId, [
                'id',
                'fk_model_id',
                'column_name',
                'description',
                'title',
                'uidt',
                'dt',
                'np',
                'ns',
                'clen',
                'cop',
                'pk',
                'rqd',
                'un',
                'ct',
                'ai',
                'unique',
                'cdf',
                'cc',
                'csn',
                'dtx',
                'dtxp',
                'dtxs',
                'au',
                'pv',
                'order',
                'base_id',
                'source_id',
                'system',
                'meta',
                'readonly'
            ]);
            if (column.meta && typeof column.meta === 'object') {
                insertObj.meta = JSON.stringify(column.meta);
            }
            if (column.validate) {
                if (typeof column.validate === 'string') insertObj.validate = column.validate;
                else insertObj.validate = JSON.stringify(column.validate);
            }
            extractedColumnMetas.push(insertObj);
            columns.push(colWithId);
        }
        if (columns.length === 0) return [];
        // bulk insert columns
        await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, extractedColumnMetas, true);
        await Column.bulkInsertColOption(context, columns, ncMeta);
        return columns;
    }
    static async bulkInsertColOption(context, columns, ncMeta = _Noco.default.ncMeta) {
        const insertGroups = new Map();
        for (const column of columns){
            const groupKey = column.uidt === _nocodbsdk.UITypes.MultiSelect ? _nocodbsdk.UITypes.SingleSelect : column.uidt;
            let insertArr = insertGroups.get(groupKey);
            if (!insertArr) {
                insertGroups.set(groupKey, insertArr = []);
            }
            switch(column.uidt || column.ui_data_type){
                case _nocodbsdk.UITypes.Lookup:
                    // LookupColumn.insert()
                    insertArr.push({
                        fk_column_id: column.id,
                        fk_relation_column_id: column.fk_relation_column_id,
                        fk_lookup_column_id: column.fk_lookup_column_id
                    });
                    break;
                case _nocodbsdk.UITypes.Rollup:
                    {
                        insertArr.push({
                            fk_column_id: column.id,
                            fk_relation_column_id: column.fk_relation_column_id,
                            fk_rollup_column_id: column.fk_rollup_column_id,
                            rollup_function: column.rollup_function
                        });
                        break;
                    }
                case _nocodbsdk.UITypes.Links:
                case _nocodbsdk.UITypes.LinkToAnotherRecord:
                    {
                        insertArr.push({
                            fk_column_id: column.id,
                            type: column.type,
                            fk_child_column_id: column.fk_child_column_id,
                            fk_parent_column_id: column.fk_parent_column_id,
                            fk_mm_model_id: column.fk_mm_model_id,
                            fk_mm_child_column_id: column.fk_mm_child_column_id,
                            fk_mm_parent_column_id: column.fk_mm_parent_column_id,
                            ur: column.ur,
                            dr: column.dr,
                            fk_index_name: column.fk_index_name,
                            fk_related_model_id: column.fk_related_model_id,
                            virtual: column.virtual
                        });
                        break;
                    }
                case _nocodbsdk.UITypes.QrCode:
                    {
                        insertArr.push({
                            fk_column_id: column.id,
                            fk_qr_value_column_id: column.fk_qr_value_column_id
                        }, ncMeta);
                        break;
                    }
                case _nocodbsdk.UITypes.Barcode:
                    {
                        insertArr.push({
                            fk_column_id: column.id,
                            fk_barcode_value_column_id: column.fk_barcode_value_column_id,
                            barcode_format: column.barcode_format
                        });
                        break;
                    }
                case _nocodbsdk.UITypes.Formula:
                    {
                        insertArr.push({
                            fk_column_id: column.id,
                            formula: column.formula,
                            formula_raw: column.formula_raw,
                            parsed_tree: column.parsed_tree
                        });
                        break;
                    }
                case _nocodbsdk.UITypes.MultiSelect:
                    {
                        var _column_colOptions;
                        if (!((_column_colOptions = column.colOptions) == null ? void 0 : _column_colOptions.options)) {
                            var _column_dtxp;
                            for (const [i, option] of ((_column_dtxp = column.dtxp) == null ? void 0 : _column_dtxp.split(',').entries()) || [].entries()){
                                insertArr.push({
                                    fk_column_id: column.id,
                                    title: option.replace(/^'/, '').replace(/'$/, ''),
                                    order: i + 1,
                                    color: selectColors[i % selectColors.length]
                                });
                            }
                        } else {
                            for (const [i, option] of column.colOptions.options.entries() || [].entries()){
                                // Trim end of enum/set
                                if (column.dt === 'enum' || column.dt === 'set') {
                                    option.title = option.title.trimEnd();
                                }
                                insertArr.push(_extends({
                                    color: selectColors[i % selectColors.length]
                                }, (0, _extractProps.extractProps)(option, [
                                    'title',
                                    'fk_column_id',
                                    'color'
                                ]), {
                                    fk_column_id: column.id,
                                    order: i + 1
                                }));
                            }
                        }
                        break;
                    }
                case _nocodbsdk.UITypes.SingleSelect:
                    {
                        var _column_colOptions1;
                        if (!((_column_colOptions1 = column.colOptions) == null ? void 0 : _column_colOptions1.options)) {
                            var _column_dtxp1;
                            for (const [i, option] of ((_column_dtxp1 = column.dtxp) == null ? void 0 : _column_dtxp1.split(',').entries()) || [].entries()){
                                insertArr.push({
                                    fk_column_id: column.id,
                                    title: option.replace(/^'/, '').replace(/'$/, ''),
                                    order: i + 1,
                                    color: selectColors[i % selectColors.length]
                                });
                            }
                        } else {
                            for (const [i, option] of column.colOptions.options.entries() || [].entries()){
                                // Trim end of enum/set
                                if (column.dt === 'enum' || column.dt === 'set') {
                                    option.title = option.title.trimEnd();
                                }
                                insertArr.push(_extends({
                                    color: selectColors[i % selectColors.length]
                                }, (0, _extractProps.extractProps)(option, [
                                    'title',
                                    'fk_column_id',
                                    'color'
                                ]), {
                                    fk_column_id: column.id,
                                    order: i + 1
                                }));
                            }
                        }
                        break;
                    }
                case _nocodbsdk.UITypes.LongText:
                    {
                        var _column_meta;
                        if (((_column_meta = column.meta) == null ? void 0 : _column_meta[_nocodbsdk.LongTextAiMetaProp]) === true) {
                            insertArr.push({
                                fk_model_id: column.fk_model_id,
                                fk_column_id: column.id,
                                fk_integration_id: column.fk_integration_id,
                                model: column.model,
                                prompt: column.prompt,
                                prompt_raw: column.prompt_raw,
                                error: column.error
                            });
                        }
                        break;
                    }
            }
        }
        // bulk insert column options
        for (const group of insertGroups.keys()){
            switch(group){
                case _nocodbsdk.UITypes.SingleSelect:
                case _nocodbsdk.UITypes.MultiSelect:
                    await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.COL_SELECT_OPTIONS, insertGroups.get(group));
                    break;
                case _nocodbsdk.UITypes.Lookup:
                    await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.COL_LOOKUP, insertGroups.get(group));
                    break;
                case _nocodbsdk.UITypes.Rollup:
                    await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.COL_ROLLUP, insertGroups.get(group));
                    break;
                case _nocodbsdk.UITypes.Links:
                case _nocodbsdk.UITypes.LinkToAnotherRecord:
                    await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.COL_RELATIONS, insertGroups.get(group));
                    break;
                case _nocodbsdk.UITypes.QrCode:
                    await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.COL_QRCODE, insertGroups.get(group));
                    break;
                case _nocodbsdk.UITypes.Barcode:
                    await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.COL_BARCODE, insertGroups.get(group));
                    break;
                case _nocodbsdk.UITypes.Formula:
                    await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.COL_FORMULA, insertGroups.get(group));
                    break;
                case _nocodbsdk.UITypes.LongText:
                    await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.COL_LONG_TEXT, insertGroups.get(group));
                    break;
            }
        }
    }
    static async deleteCoverImageColumnId(context, id, ncMeta = _Noco.default.ncMeta) {
        const promises = [];
        // Gallery views
        const galleryViews = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.GALLERY_VIEW, {
            condition: {
                fk_cover_image_col_id: id
            }
        });
        for (const galleryView of galleryViews){
            promises.push(_models.GalleryView.update(context, galleryView.fk_view_id, {
                fk_cover_image_col_id: null
            }, ncMeta));
        }
        // Kanban views
        const kanbanViews = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.KANBAN_VIEW, {
            condition: {
                fk_cover_image_col_id: id
            }
        });
        for (const kanbanView of kanbanViews){
            promises.push(_models.KanbanView.update(context, kanbanView.fk_view_id, {
                fk_cover_image_col_id: null
            }, ncMeta));
        }
        await Promise.all(promises);
    }
    constructor(data){
        Object.assign(this, data);
    }
};
_ts_decorate([
    (0, _nccachedecorator.NcCache)({
        key: (args, thisArg)=>thisArg.id,
        onCacheHit: async (_args, result, thisArg)=>{
            thisArg.colOptions = result;
        }
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], Column.prototype, "getColOptions", null);
_ts_decorate([
    (0, _nccachedecorator.NcCache)({
        key: (args)=>{
            var _args__fk_default_view_id;
            return `${args[1].fk_model_id}:${(_args__fk_default_view_id = args[1].fk_default_view_id) != null ? _args__fk_default_view_id : 'default'}`;
        }
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        Object,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], Column, "list", null);
_ts_decorate([
    (0, _nccachedecorator.NcCache)({
        key: (args)=>args[1].colId
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        Object,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], Column, "get", null);
